import React from 'react';

const NotificationModal = ({ isOpen, onClose, title, message, type = 'info' }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm animate-fadeIn">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 border border-primary/20 overflow-hidden relative animate-scaleIn">
                <div className="absolute top-0 left-0 w-full h-2 bg-primary"></div>

                <div className="flex flex-col items-center text-center">
                    <div className="w-16 h-16 bg-primary-light rounded-full flex items-center justify-center mb-6">
                        <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            {type === 'success' ? (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            ) : (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            )}
                        </svg>
                    </div>

                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                        {title}
                    </h3>

                    <div className="text-gray-600 mb-8 leading-relaxed whitespace-pre-line">
                        {message}
                    </div>

                    <button
                        onClick={onClose}
                        className="w-full bg-primary text-white py-3.5 px-6 rounded-xl font-semibold hover:bg-primary-dark transition-all duration-200 shadow-md hover:shadow-lg active:scale-[0.98]"
                    >
                        Tamam
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotificationModal;
